
import { defineComponent } from "vue";
import CreatorsListItem from "@/modules/market/components/CreatorsListItem.vue";
import CreatorsFeaturedItem from "@/modules/market/components/CreatorsFeaturedItem.vue";

export default defineComponent({
  components: {
    CreatorsFeaturedItem,
    CreatorsListItem,
  },
  props: {
    creators: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const tokens = [
      {
        name: "An Interstellar Wanderer",
        username: "@rananhunt88",
        likes: 193,
        liked: true,
        img: "https://picsum.photos/200/300",
      },
      {
        name: "Pepe community on tour",
        username: "@huntlacer",
        likes: 50,
        liked: false,
        img: "https://picsum.photos/200/300",
      },
      {
        name: "Mixed Girl Power",
        username: "@aslanruby",
        likes: 120,
        liked: true,
        img: "https://picsum.photos/200/300",
      },
    ];

    return { tokens };
  },
});
